export enum FinancialCategoryCreditEnum {
    LOAN = 'LOAN',
    OTHER = 'OTHER',
}

export enum FinancialCategoryCreditLabelEnum {
    LOAN = 'Empréstimo',
    OTHER = 'Outro',
}
